<template>
  <div
:class="[
    ' z-50 transition-all duration-300',
    isScrolled ? 'fixed top-0 bg-white shadow-md' : ' top-0 left-0 laptop:relative'
  ]"
>
    <header
:class="[
      'mainHeader w-full z-50 transition-all duration-300 mobile:!p-0',
      isScrolled
        ? 'fixed top-0 bg-white shadow-md'
        : 'absolute top-0 left-0 laptop:relative !bg-transparent'
    ]"
>
      <nav
        class="navbar laptop:h-24 largeDesktop:h-24 mobile:h-auto navbar-expand-lg shadow-md mobile:px-2 largeDesktop:px-3 py-3 px-lg-2 z-10 mobile:rounded-br-[40px] tablet:rounded-br-3xl bg-white"
>
        <div class="container-fluid">
          <div class="flex items-center gap-3 justify-between w-full">
<!-- Logo -->
            <a
:class="[
              'relative flex items-center rounded-full border-2 shadow-lg border-white p-0 transition-all duration-300 mr-5',
              isScrolled
                ? 'w-10 h-10 laptop:w-20 laptop:h-20 desktop:w-20 desktop:h-20'
                : 'mobile:w-14 mobile:h-14 laptop:w-28 laptop:h-28 largeDesktop:w-36 largeDesktop:h-36 laptop:top-9 largeDesktop:top-11'
            ]"
>
              <img src="../../../assets/images/fyxifyLogo.png" alt="Logo" class="w-full h-full object-contain">
            </a>
            <div v-for="(item, index) in navItems" :key="index">
              <!-- <component :is="index === 0 ? 'router-link' : 'a'" :to="index === 0 ? item.link : null"
                :href="index !== 0 ? item.link : null" :target="index !== 0 ? '_blank' : null"
                :rel="index !== 0 ? 'noopener noreferrer' : null" :class="[
                  'rounded-full mobile:w-full mobile:block largeDesktop:inline-block',
                  'largeDesktop:px-5 largeDesktop:py-2 tablet:py-1.5 laptop:px-4 mobile:py-1.5 mobile:text-[15px]',
                  'mobile:px-4 py-2.5 no-underline transition-colors !border-0',
                  hoveredIndex === index ? 'text-white cursor-pointer' : 'text-black cursor-pointer'
                ]" :style="{
                      background: hoveredIndex === index
                        ? 'linear-gradient(to right, #16BCFF, #168EFF)'
                        : '#f3f4f6'
                    }" @mouseover="hoveredIndex = index" @mouseleave="hoveredIndex = null">
                {{ item.label }}
              </component> -->
              <a 
                :href="item.link" target="_blank"
                :class="[
                  'rounded-full mobile:w-full mobile:block largeDesktop:inline-block',
                  'largeDesktop:px-5 largeDesktop:py-2 tablet:py-1.5 laptop:px-4 mobile:py-1.5 mobile:text-[15px]',
                  'mobile:px-4 py-2.5 no-underline transition-colors !border-0',
                  hoveredIndex === index ? 'text-white cursor-pointer' : 'text-black cursor-pointer'
                ]" :style="{
                      background: hoveredIndex === index
                        ? 'linear-gradient(to right, #16BCFF, #168EFF)'
                        : '#f3f4f6'
                    }" @mouseover="hoveredIndex = index" @mouseleave="hoveredIndex = null"
>
                {{ item.label }}
              </a>
            </div>
          </div>
        </div>
      </nav>
</header>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false,
      hoveredIndex: null,
      navItems: [
        // { label: 'How fyxify works', link: '/protection-plan/nrg/bundle-list' },
        { label: 'Contact Us', link: 'https://fyxify.pro/index.html#ContactUs' }
      ],
    };
  },

  mounted() {

    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
  }
};
</script>
<style>
@media (max-width: 768px) {

  .collapse:not(.show) {
    display: none;
  }

  .collapse.show {
    display: block;
    height: auto;
    visibility: visible;
  }
}

@media (min-width: 768px) {

  .collapse:not(.show) {
    display: none
  }

  .collapse.show {
    display: block;
    height: auto;
    visibility: visible;
  }
}

a.router-link-active {
  border-bottom: 0 !important;
}
</style>